import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  iconWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 0,
    paddingRight: 0,
    width: '100%',
    height: '48px',
    fontDefault: 14,
    lineHeight: '16px',
    color: colors.space,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    marginRight: spacing[5],

    desktopDesign: {
      height: '53px',
    },
    maxWidthTablet: {
      fontDefault: 12,
      marginLeft: spacing[1],
    },
  },

  iconWrap: {
    marginRight: '6px',
  },
});

export default styles;
